import React from "react"

export function WinnerTitle(props) {
  return <h2 style={{textAlign: "center"}}>You are winner!</h2>
}